import {GridSettings} from "handsontable/settings";
import {MONTHS} from "../../../../constants/Months";

export type TUnitTypeData = {
    unitTypeId: string;
    unitTypeName: string;
    pmsValues: (number | null)[];
    currentForecastedValues: (number | null)[];
    newForecastedValues: (number | null)[];
    useNewForecasedValues: boolean;
};

export type PendingUpdates = {
    unitTypeUpdates: Map<string, (number | null | undefined)[]>; // unit type id -> 12 values array
};

export type HOTData = {
    tableData: Required<GridSettings["data"]>;
    rowNumToUnitTypeId: Record<number, string>;
    currentValuesByUnitTypeId: Record<string, (number | null)[]>;
    colHeaders: string[];
};


export function buildHOTData(
    rawData: TUnitTypeData[]
): {data: HOTData, updates: PendingUpdates;} {
    const COLHEADERS: string[] = [
        "Unit Type",
        ...MONTHS,
    ];
    const tableData = [];
    const currentValuesByUnitTypeId: HOTData["currentValuesByUnitTypeId"] = {};
    const pendingUpdates: PendingUpdates = {unitTypeUpdates: new Map()};
    tableData.push(COLHEADERS);

    const rowNumToUnitTypeId: Record<number, string> = {};
    for(const utData of rawData) {
        const newValues = new Array(12).fill(null);
        const utPending = new Array(12).fill(undefined);
        currentValuesByUnitTypeId[utData.unitTypeId] = utData.currentForecastedValues;
        for(let i = 0; i < 12; i++) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            let newValue: number | null = utData.pmsValues[i]!;
            if(newValue == null) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                newValue = utData.currentForecastedValues[i]!;
            }
            else {
                utPending[i] = newValue;
            }
            newValues[i] = newValue;
        }
        pendingUpdates.unitTypeUpdates.set(utData.unitTypeId, utPending);
        tableData.push([
            utData.unitTypeName,
            ...newValues,
        ]);
        rowNumToUnitTypeId[tableData.length - 1] = utData.unitTypeId;
        tableData.push([
            "    Current Values",
            ...utData.currentForecastedValues,
        ]);
        tableData.push([
            "    PMS Values",
            ...utData.pmsValues
        ]);
    }
    const mergedUpdates = mergeUpdates(undefined, pendingUpdates, currentValuesByUnitTypeId);
    return {
        data: {
            tableData,
            rowNumToUnitTypeId,
            colHeaders: COLHEADERS,
            currentValuesByUnitTypeId,
        },
        updates: mergedUpdates
    };
}

export function mergeUpdates(base: PendingUpdates | undefined, updateWith: PendingUpdates, currentValues: Record<string, (number | null)[]>): PendingUpdates {
    const result: PendingUpdates = {
        unitTypeUpdates: base ? new Map(base.unitTypeUpdates) : new Map()
    };
    for(const [unitTypeId, updateRow] of Array.from(updateWith.unitTypeUpdates)) {
        let resultRow = result.unitTypeUpdates.get(unitTypeId);
        if(!resultRow) {
            resultRow = new Array(12).fill(undefined);
            result.unitTypeUpdates.set(unitTypeId, resultRow);
        }
        const unitTypeCurrentValues = currentValues[unitTypeId];
        for(let i = 0; i < 12; i++) {
            const updateVal = updateRow[i];
            if(updateVal !== undefined) {
                const currentVal = unitTypeCurrentValues?.[i];
                if(updateVal == currentVal) {
                    resultRow[i] = undefined;
                }
                else {
                    resultRow[i] = updateVal;
                }
            }
        }
    }
    return result;
}
